export enum ReserveStatus {
    None = 0,
    NearReserve = 1,
    ReserveMet = 2,
    NoReserve = 3,
}
